import React, { createRef, useEffect, useState } from 'react'
import classNames from 'classnames'
import { mutate } from 'swr'
import { toast } from 'react-toastify'
import { muteUserNotifications, seenUserNotifications } from '../../utils/notificationsAPIs'
import NotificationItems from '../NotificationItems/NotificationItems'
import styles from './NotificationContainer.module.scss'

const NotificationContainer = ({
  id,
  notificationData = [],
  fromDropdown = false,
  isDropdownOpen
}) => {
  const [msgRefs, setMsgRefs] = useState([])
  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    const tempMsgRefs = []
    notificationData.forEach((item, index) => {
      tempMsgRefs[index] = createRef(null)
    })
    setMsgRefs(tempMsgRefs)
    setNotifications(notificationData)
  }, [notificationData])

  const updateIsSeenStatus = async (index, item) => {
    const { isSeen, notificationMachineName } = item
    if (isSeen) return
    const data = [{ notificationMachineName }]
    const response = await seenUserNotifications(data)
    if (response.statusCode == 200) {
      const updatedNotifs = Object.assign([], notifications)
      updatedNotifs[index].isSeen = true
      mutate('/api/notifications', { data: updatedNotifs }, false)
    } else {
      toast.error(`Seen Notification Status Update Failed ${response.message}`)
    }
  }

  const updateIsMutedStatus = async (index, notificationMachineName, unmuteNotification) => {
    const data = [{ notificationMachineName }]
    if (unmuteNotification) {
      data[0].unmuteNotification = unmuteNotification
    }
    const response = await muteUserNotifications(data)
    if (response.statusCode == 200) {
      const updatedNotifs = Object.assign([], notifications)
      updatedNotifs[index].isMuted = !unmuteNotification
      mutate('/api/notifications', { data: updatedNotifs }, false)
    } else {
      toast.error(`Muted Notification Status Update Failed ${response.message}`)
    }
  }

  const handleUpdateIsMuted = (index, machineName, isUnmute, e) => {
    e.preventDefault()
    e.stopPropagation()
    updateIsMutedStatus(index, machineName, isUnmute)
  }

  const showNoResult = () => {
    let showNoResult = false
    const length = notifications.length
    if (length == 0) showNoResult = true
    if (fromDropdown && notifications.filter((i) => i.isMuted).length == length) showNoResult = true
    return showNoResult
  }

  return (
    <div
      id={id}
      className={classNames(styles.notificationsContainer, {
        'dropdown-content': fromDropdown,
        'no-result': !notificationData.length
      })}
    >
      {showNoResult() ? (
        <h5 className="lead text-center p-4 mb-0">
          {fromDropdown ? (
            <span>
              No notifications found. <br />
              Muted notifications will not be displayed here.
            </span>
          ) : (
            <span>No notifications found.</span>
          )}
        </h5>
      ) : (
        <NotificationItems
          notifications={notifications}
          msgRefs={msgRefs}
          handleUpdateIsMuted={handleUpdateIsMuted}
          handleUpdateIsSeen={updateIsSeenStatus}
          fromDropdown={fromDropdown}
          isDropdownOpen={isDropdownOpen}
        />
      )}
    </div>
  )
}

export default NotificationContainer
